angular.
module("dx.webapp.printing").
directive("dxPrintFinalGrades", function printFinalGradesDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			student: "=",
			examParts: "=",
			showStudentNames: "=?",
			showEmail: "=?",
			showStudentCodes: "=?",
		},
		templateUrl: "tmpl/printing/print-final-grades-directive.html",
		controller: "dxPrintFinalGradesController",
		controllerAs: "vm",
		bindToController: true,
	};
});
